import React, { ReactNode } from 'react';
import { defineMessages, IntlShape, useIntl } from 'react-intl';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { InputGroup } from '../../edit/components/layout/InputGroup';

const messages = defineMessages({placeholder: {id: 'search.placeholder'}});

export interface SearchbarProps {
  searchTerm: string;
  onSearchTermChange: (term: string) => void;
  onSubmit: () => void;
}

export function Searchbar(props: SearchbarProps): ReactNode {
  const intl: IntlShape = useIntl();

  const handleKeyUp = (e: React.KeyboardEvent<HTMLElement>): void => {
    if (e.key === 'Enter') props.onSubmit();
  };

  return (
    <InputGroup>
      <InputText
        value={props.searchTerm}
        autoFocus={true}
        onChange={(e): void => props.onSearchTermChange(e.target.value)}
        onKeyUp={(e): void => handleKeyUp(e)}
        placeholder={intl.formatMessage(messages.placeholder)}>
      </InputText>
      <Button icon="pi pi-search" className="p-button" onClick={(): void => props.onSubmit()}/>
    </InputGroup>
  );
}
